export default function CAEditCustomerSettingsDirective() {
  return {
    template: require('./edit-customer-settings.directive.html'),
    scope: {
      customer: '=',
    },
    controller: 'CAEditCustomerSettingsDirectiveController',
    controllerAs: 'editCustomerSettingsVM',
    bindToController: true,
    replace: true,
  };
}
